module.exports = __webpack_public_path__ + "img/claim.354326a6.svg";